<template>
	<div style="height: 100%">
		<template v-for="subApp in microApps" >
			<micro-app
				style="height: 100%"
				:key="subApp.name"
				v-if="mountedFlag"
				v-show="isShow === subApp.name"
				:name="subApp.name"
				:url="subApp.port"
        :destroy="true"
				@created="created(subApp.name)"
				@beforemount="beforemount(subApp.name)"
				@mounted="mounted(subApp.name)"
				@unmount="unmount(subApp.name)"
        @datachange='handleDataChange'
				:data="microData"
				keep-alive
			></micro-app>
		</template>
	</div>
</template>


<script>
import { microConfig } from "../port-config";
import auth from "@/utils/auth";
import Tools from "@/utils/tools"
export default {
	data() {
		return {
			microApps: [], // 所渲染的子应用
			mountedFlag: false, // 延时渲染，处理应用异步加载时序
			isShow: "",
			// num: 0,
			loading: null,
		};
	},
	created() {
    // 解决初始化bug
    const { path } = this.$route
    microConfig.forEach((item) => {
      if(path === `/main/${item.name}/`) {
        this.isShow = item.name
      }
    })
	},
	mounted() {},
	computed: {
		microAppArr() {
			return this.$store.state.micro.microAppArr;
		},
		microData() {
			return this.$store.state.micro.microData;
		},
		moduleName() {
			const { module } = this.$store.state.micro.showApp.module ? this.$store.state.micro.showApp : "";
			return module;
		},
	},
	watch: {
		microAppArr() {
			this.microApps = [];
			microConfig.forEach((item) => {
				const subApp = this.microAppArr.find((app) => item.name === app);
				subApp && this.microApps.push(item);
			});
			this.mountedFlag = true;
		},
		$route: {
			handler: function (val, oldVal) {
				// 根据路由监听显示哪个子应用
				const { path } = val;
				// console.log(this.microAppArr);

				let flag = false
				try {
					this.microAppArr.forEach((item) => {
						if (path.includes(item)) {
							this.isShow = item
							flag = true
							throw new Error('')
						}
					})
				} catch (error) {}
				flag ? '' : (this.isShow='')
				// if (path.includes(this.moduleName)) {
				// 	if (this.isShow != this.moduleName) {
				// 		this.isShow = this.moduleName;
				// 	}
				// } else {
				// 	this.isShow = "";
				// }
				// console.log("显示的子应用： ", this.isShow);
			},
			deep: true,
			immediate: true,
		},
	},

	methods: {
		created(val) {
			console.log("micro-app元素被创建，子应用创建", val);
			// if (this.num == 0) {
				// 开启预加载后this.$loading 组件加载缓慢
				// this.loading = this.$loading({
				// 	lock: true,
				// 	text: "应用加载中...",
				// 	spinner: "el-icon-loading",
				// 	background: "rgba(0, 0, 0, 0.6)",
				// });
			// }
		},
		beforemount(val) {
			console.log(`${val}即将被渲染`);
		},
		mounted(val) {
			console.log(`%c${val}已经渲染完成`,'color: #67c23a;font-size: 18px');
			// this.num++;
			// if (this.num === this.microApps.length) {
			// 	this.loading.close();
			// }
		},
		unmount(val) {
			console.log(`${val}已经卸载`);
		},
    handleDataChange (e) {
      // console.log('来自子应用的数据：',e, e.detail.data)
      const { code, msg, type } = e.detail.data
      if(code === 10001) {
        Tools.alert(msg, type)
        auth.removeToken()
        let tabHome = this.$store.state.system.tab[0]
        tabHome.active = true
        this.$store.commit("system/setTab", [tabHome])
        this.$store.commit("system/setTab2", [])
        sessionStorage.removeItem("vuex")

        this.Tools.ssoOutLogin()
      }
    }
	},
};
</script>



// WEBPACK FOOTER //
// src/micro-app/component/microSub.vue